import { render } from "./ShipmentList_address.vue?vue&type=template&id=2e693bff&scoped=true"
import script from "./ShipmentList_address.vue?vue&type=script&lang=js"
export * from "./ShipmentList_address.vue?vue&type=script&lang=js"

import "./ShipmentList_address.vue?vue&type=style&index=0&id=2e693bff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e693bff"]])

export default __exports__